<template>
  <div class="text-center mb-3">
    <h2 class="titulo-video">Descuentos y Promociones</h2>
  </div>
  <div class="ratio ratio-16x9 mb-4">
    <iframe
        src="https://player.vimeo.com/video/1090644455"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
    ></iframe>
  </div>
  <h2 class="text-center mb-4" style="font-family: Arial, sans-serif; font-weight: 700; color: #4b0082;">Completa las preguntas:</h2>
</template>

<style scoped>
.titulo-video {
  font-family: Arial, sans-serif;
  font-weight: 700;
  color: #4b0082;
}
</style>